'use client'

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    return (
        <html>
            <body>
                <div className="flex min-h-screen flex-col items-center justify-center p-24">
                    <h2 className="text-2xl font-bold mb-4">Algo deu errado!</h2>
                    <button
                        className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                        onClick={() => reset()}
                    >
                        Tentar novamente
                    </button>
                </div>
            </body>
        </html>
    )
}
